import {
  HIDE_QUOTA_PAYWALL,
  HIDE_SESSION_ENDED,
  OPEN_PLANS,
  REQUEST_TUTOR_RESTART,
  SET_BUY_MORE,
  SET_PLAN_INFO,
  SHOW_QUOTA_PAYWALL,
} from './actionTypes';

// What opened the plans: a used-up allowance or content outside the plan. A session that simply
// ended is not a limit (owner 2026-09-29; Sol build-plan D8): it shows a quiet line, not the plans.
const KINDS = ['quota', 'ended', 'locked'];

export const initialState = {
  visible: false,
  exhausted: null,
  buyMore: false,
  plan: null,
  sessionEnded: false,
  tutorRestart: null,
};

export default function subscriptionUi(state = initialState, action) {
  switch (action.type) {
    case SHOW_QUOTA_PAYWALL: {
      const kind = KINDS.includes(action.payload?.kind) ? action.payload.kind : 'quota';
      if (kind === 'ended') return {...state, sessionEnded: true};
      return {
        ...state,
        visible: true,
        sessionEnded: false,
        exhausted: {
          kind,
          meter: action.payload?.meter || null,
          planKey: action.payload?.planKey || null,
          allowed: action.payload?.allowed ?? null,
          used: action.payload?.used ?? null,
          remaining: action.payload?.remaining ?? 0,
          resetAt: action.payload?.resetAt || null,
          message: action.payload?.message || null,
          otherMeter: action.payload?.otherMeter || null,
          otherSecondsLeft: action.payload?.otherSecondsLeft ?? 0,
          subject: action.payload?.subject || null,
          // A locked unit: the learner's grade, for "Only Unit 1 from grade N is free." (owner 2026-10-02).
          grade: action.payload?.grade ?? null,
        },
      };
    }
    case OPEN_PLANS:
      return {...state, visible: true, exhausted: null};
    case HIDE_QUOTA_PAYWALL:
      return {...state, visible: false, exhausted: null};
    case SET_BUY_MORE:
      return {...state, buyMore: action.payload};
    case SET_PLAN_INFO:
      return {...state, plan: action.payload};
    case HIDE_SESSION_ENDED:
      return {...state, sessionEnded: false};
    case REQUEST_TUTOR_RESTART:
      return {...state, sessionEnded: false, tutorRestart: {mode: action.payload, at: (state.tutorRestart?.at || 0) + 1}};
    default:
      return state;
  }
}
